export const formatPercentage = (per: GLfloat) =>
  (per * 100).toFixed(2).toString() + " %";

export const roundValue = (val: GLfloat) => (val ? val.toFixed(2) : "0.00");

export const formatValuta = (amount: GLfloat) =>
  amount ? amount.toFixed(2).toString() + " $" : "0.00 $";
